import { AgmMap, MapsAPILoader } from '@agm/core';
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Debounce from 'debounce-decorator';

@Component({
  selector: 'app-maps-content',
  templateUrl: './maps-content.component.html'
})
export class MapsContentComponent implements OnChanges {
  @Input() public latitude: number;
  @Input() public longitude: number;
  @Input() public zoom: number;
  @Input() public mapTitle: string;
  @Input() public address: string;

  @Output() public updateCoordinates: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('map') public map: AgmMap;

  constructor(private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    public activeModal: NgbActiveModal) {
    this.initializeMap();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.changeCoordinates(changes);
  }

  @Debounce(50)
  private changeCoordinates(changes: SimpleChanges) {
    const latitudeChange: SimpleChange = changes['latitude'];
    const longitudeChange: SimpleChange = changes['longitude'];
    const addressChange: SimpleChange = changes['address'];

    if (latitudeChange || longitudeChange) {
      if (latitudeChange) {
        this.latitude = latitudeChange.currentValue;
      }

      if (longitudeChange) {
        this.longitude = longitudeChange.currentValue;
      }

      if (addressChange) {
        this.address = addressChange.currentValue;
      }

      this.initializeMap();
    }
  }

  private initializeMap(): void {
    this.zoom = 10;

    this.latitude = this.latitude || -25.717530;
    this.longitude = this.longitude || 28.031360;

    this.geoCodeLatLng({
      lat: this.latitude,
      lng: this.longitude
    })
  }

  public mapClicked(event: { coords: { lat: number, lng: number } }): void {
    this.markerMoved(event);
  }

  public markerMoved(event: { coords: { lat: number, lng: number } }) {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ 'location': event.coords },
      (res, status) => {
        if (status === google.maps.GeocoderStatus.OK && res.length) {
          this.ngZone.run(() => this.setLocation(res[0]));
        }
      })
  }

  private setLocation(place: google.maps.GeocoderResult): void {
    this.latitude = place.geometry.location.lat();
    this.longitude = place.geometry.location.lng();

    this.geoCodeLatLng(place.geometry.location);
  }

  private geoCodeLatLng(latlng: google.maps.LatLng | google.maps.LatLngLiteral) {
    this.mapsAPILoader.load().then(() => {

      new google.maps.Geocoder().geocode({ 'location': latlng }, (results, status) => {
        if (results[0]) {
          this.address = results[0].formatted_address;

          this.updateCoordinates.emit({
            latitude: this.latitude,
            longitude: this.longitude,
            address: this.address
          })
        }
      });
    });
  }
}
